import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'element-plus/dist/index.css'
import './assets/scss/index.scss'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './lang'
import './permission' // permission control

const app = createApp(App)
app.use(store)
app.use(router)
app.use(i18n)
app.use(ElementPlus, { size: 'large' })

app.mount('#app')
